import React, { useEffect, useContext, useRef, useState } from 'react';
import styled from 'styled-components/macro';
import EditorContext from '../../modules/contexts/editor';
import { sizes } from '../../modules/defines/style';

const SplitterLine = styled.div`
    border-bottom: thin solid lightgray;
    margin-top: ${sizes.splitterHeight / 2}px;
    height: ${sizes.splitterHeight}px;
    padding-right: 95%;
    cursor: row-resize;
`;

const Splitter = ({ topPane, bottomPane }) => {
    const splitter = useRef(null);
    const dragging = useRef(false);
    const topPaneRef = useRef(null);
    const bottomPaneRef = useRef(null);
    const editor = useContext(EditorContext);

    const mouseDown = (e) => {
        dragging.current = true;
        splitter.current.style.position = 'absolute';
        splitter.current.style.top = `${splitter.current.offsetTop}px`;
    };

    const mouseMoved = (e) => {
        if (dragging.current) {
            const topHeight = e.clientY - splitter.current.offsetParent.offsetTop;
            splitter.current.style.top = `${topHeight - sizes.splitterHeight}px`;
            if (topPaneRef.current) {
                topPaneRef.current.style.height = splitter.current.style.top;
                if (bottomPaneRef.current) {
                    bottomPaneRef.current.style.height = `${topPaneRef.current.parentElement.offsetHeight - topHeight - sizes.splitterHeight}px`;
                }
            }
        }
    };

    const mouseUp = (e) => {
        if (dragging.current) {
            splitter.current.style.position = 'inherit';
            dragging.current = false;
        }
    };

    useEffect(() => {
        document.addEventListener('mousemove', mouseMoved);
        document.addEventListener('mouseup', mouseUp);
        return () => {
            document.removeEventListener('mousemove', mouseMoved);
            document.removeEventListener('mouseup', mouseUp);
        };
    }, []);

    useEffect(() => {
        if (topPane) {
            topPaneRef.current = topPane;
            topPane.style.height = `${sizes.lessonEditor * sizes.split - sizes.splitterHeight}px`;
        }
        if (bottomPane) {
            bottomPaneRef.current = bottomPane;
            bottomPane.style.height = `${sizes.lessonEditor * (1 - sizes.split) - sizes.splitterHeight}px`;
        }
    }, [topPane, bottomPane]);

    return (
        <SplitterLine
            ref={splitter} onMouseDown={mouseDown} dragging={dragging.current}
        />
    );
};

export default Splitter;
